import { ChartConfiguration, Chart as ChartJS } from "chart.js";

export const crosshairPlugin = {
  id: "crosshair",
  afterDraw: (chart: ChartJS<"line" | "bar">) => {
    const activeElements = chart.tooltip?.getActiveElements();
    if (
      activeElements?.length &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
      (chart.config as ChartConfiguration<"line" | "bar">).type === "line"
    ) {
      const activePoint = activeElements.reduce((max, current) =>
        current.element.y < max.element.y ? current : max,
      );
      const { ctx } = chart;
      const { x, y } = activePoint.element;
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      const bottomY = chart.scales.y.bottom;

      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, y);
      ctx.lineTo(x, bottomY);
      ctx.lineWidth = 1;
      ctx.setLineDash([3, 3]);
      ctx.strokeStyle = "rgba(0, 0, 0, 0.3)";
      ctx.stroke();
      ctx.restore();

      for (const point of activeElements) {
        if (point.element.y) {
          ctx.beginPath();
          ctx.arc(x, point.element.y, 3, 0, 2 * Math.PI);
          ctx.fillStyle = point.element.options.borderColor;
          ctx.fill();
        }
      }
    }
  },
};
